import request from '../utils/request'

export function projectList (params) {
  return request({
    url: '/project/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function projectClassList (params) {
  return request({
    url: '/project/class/list',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function projectDetail (params) {
  return request({
    url: '/project/detail/get',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

export function donatePay (params) {
  return request({
    url: '/donate/log/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/project.js